import { CanActivateFn } from '@angular/router';
import { environment } from '@sl/environment';

export const isNotProductionGuard: CanActivateFn = () => !environment.production;
